

const TableTypeTitle = (props) => {

    return(
        <h5 className="my-auto">{props.children}</h5>
    )
}

export default TableTypeTitle;